// extracted by mini-css-extract-plugin
export default {"BookTable":"BookTable_BookTable__VVeed","Order":"BookTable_Order__xI5k4","TableNum":"BookTable_TableNum__+BmLu","OrderNum":"BookTable_OrderNum__PyTvT"};